import { Flex, Title, Text, Button } from "@mantine/core";
import { useUpdateCustomerData } from "../../../hooks/ui/";
import { FooterButtons } from "../../footerButtons";
import { REPLAY_BLOCK_CLASS } from "../../../utils/statsig";

interface CustomerPoaConfirmationProps {
  setHandleDone?: () => void;
}

export default function CustomerConfirmation({
  setHandleDone,
}: CustomerPoaConfirmationProps) {
  const { customerData } = useUpdateCustomerData();

  return (
    <Flex justify="center" align="center">
      <Flex direction="column" maw={672} w={"100%"}>
        <Title order={2} mb="1rem" ff="var(--wallet-font-family-sambla-sans)">
          Tack <span className={REPLAY_BLOCK_CLASS}>{customerData.name}</span>!
        </Title>
        <Text mb={"lg"}>
          Nu har vi förnyat din fullmakt och kan se över ditt pensionssparande.
          Vi har också skickat en bekräftelse till din mail.
        </Text>

        <FooterButtons>
          <Button onClick={setHandleDone} mt="lg" mb="lg">
            Klar
          </Button>
        </FooterButtons>
      </Flex>
    </Flex>
  );
}
